import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import React from 'react';
import ReactDOM from 'react-dom';

var _excluded = ["as"];
function createTeleporter(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      multiSources = _ref.multiSources;

  var context = {};

  function setElement(element) {
    context.value = element;

    if (context.set && context.set.current) {
      context.set.current(element);
    }
  }

  function useTargetRef() {
    return setElement;
  }

  function Target(_ref2) {
    var _ref2$as = _ref2.as,
        As = _ref2$as === void 0 ? 'div' : _ref2$as,
        props = _objectWithoutPropertiesLoose(_ref2, _excluded);

    return /*#__PURE__*/React.createElement(As, _extends({
      ref: setElement
    }, props));
  }

  function Source(_ref3) {
    var children = _ref3.children;

    var _React$useState = React.useState(null),
        element = _React$useState[0],
        setElement = _React$useState[1];

    React.useLayoutEffect(function () {
      var setRef = {
        current: setElement
      };
      var previousSet;

      if (context.set) {
        previousSet = context.set;

        if (!multiSources) {
          context.set.current(null);
        }
      }

      context.set = setRef;
      setElement(context.value);
      return function () {
        setRef.current = null;
        context.set = null;

        if (previousSet && previousSet.current) {
          context.set = previousSet;
          context.set.current(context.value);
        }
      };
    }, []);
    if (!element) return null;
    return /*#__PURE__*/ReactDOM.createPortal(children, element);
  }

  return {
    Source: Source,
    Target: Target,
    useTargetRef: useTargetRef
  };
}

export { createTeleporter };
